var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative router-view",class:_vm.containerClass},[(_vm.loading)?_c('OverlaySpinner',{attrs:{"fixed":_vm.fixed}}):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }